"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NORMALIZED_RATINGS_FORM_LATEST = exports.NormalizedRatingsFormCodec = exports.BoundNormalizedRatingsForm = void 0;
const ratings_table_codec_1 = require("../../../../../../RatingsTable/ratings-table-codec");
const ratings_table_types_1 = require("../../../../../../RatingsTable/ratings-table.types");
const stored_ratings_table_1 = require("../../../../../../RatingsTable/stored-ratings-table");
class BoundNormalizedRatingsForm {
    constructor(seed) {
        this.seed = seed;
    }
    toFormData(payload) {
        const table = this.open(payload);
        return { formVersion: table.formVersion, kind: table.kind, signalGroups: table.signalGroups, rows: table.rows };
    }
    toCanonical(table) {
        const result = this.save(table);
        if (result.outcome === ratings_table_types_1.RatingsTableSaveOutcome.Refused) {
            throw new Error(`Rows need a "measured from" before the table can be saved: ${result.rowsNeedingReference.join(', ')}`);
        }
        return result.payload;
    }
    save(table) {
        const opened = this.open(this.seed);
        const result = ratings_table_codec_1.RatingsTableCodec.toBoundaries(this.seed.kind, BoundNormalizedRatingsForm.signalsWithPairs(this.seed.signals, this.seed.differentialPairs), this.seed.modes, this.seed.boundaries, { ...table, conditions: opened.conditions, pairs: opened.pairs }, { deletedBoundaryIds: [], dropUnstatedRowBounds: true }, this.seed.parentRows);
        if (result.outcome === ratings_table_types_1.RatingsTableSaveOutcome.Refused) {
            return result;
        }
        return {
            outcome: ratings_table_types_1.RatingsTableSaveOutcome.Saved,
            payload: {
                boundaries: result.boundaries,
                modes: result.modes,
                differentialPairs: this.seed.differentialPairs,
                table: result.table,
                parentRows: result.parentRows,
            },
        };
    }
    open(payload) {
        return ratings_table_codec_1.RatingsTableCodec.toRatingsTable(this.seed.kind, BoundNormalizedRatingsForm.signalsWithPairs(this.seed.signals, payload.differentialPairs), payload.modes, payload.boundaries, payload.table, payload.parentRows);
    }
    static signalsWithPairs(signals, pairs) {
        return signals.map((signal) => {
            const pair = pairs.find((candidate) => String(candidate.positiveId) === String(signal.id) || String(candidate.negativeId) === String(signal.id));
            return pair === undefined ?
                { id: signal.id, name: signal.name }
                : {
                    id: signal.id,
                    name: signal.name,
                    diffPair: { pairName: pair.pairName, positiveId: pair.positiveId, negativeId: pair.negativeId },
                };
        });
    }
}
exports.BoundNormalizedRatingsForm = BoundNormalizedRatingsForm;
class NormalizedRatingsFormCodec {
    constructor() {
        this.version = stored_ratings_table_1.RATINGS_TABLE_FORM_VERSION;
        this.formDataSchema = stored_ratings_table_1.StoredRatingsTableSchema;
    }
    bind(seed) {
        return new BoundNormalizedRatingsForm(seed);
    }
}
exports.NormalizedRatingsFormCodec = NormalizedRatingsFormCodec;
exports.NORMALIZED_RATINGS_FORM_LATEST = new NormalizedRatingsFormCodec();
//# sourceMappingURL=form-latest.js.map